/* AESTHETICO – Better in pairs (wall). Section: sections/aes-pair-wall.liquid */
(function () {
  function money(c) { var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function bind(root) {
    if (!root || root.dataset.bound) return;
    var dataEl = root.querySelector('[data-pw-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.bound = '1';

    var P = data.products || {};
    var sel = [data.init[0], data.init[1]];
    var size = data.size;
    var DISC = Number(root.dataset.discount) || 0;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pop = root.querySelector('[data-pop]');
    var btn = root.querySelector('[data-add]');
    var err = root.querySelector('.pw-err');
    var openFor = null;

    function vOf(h, sz) { var p = P[h]; return p && p.v ? p.v[sz || size] : null; }

    function swap(img, src, alt) {
      if (!img || !src || img.getAttribute('src') === src) return;
      img.style.opacity = '0';
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        img.src = src; if (alt != null) img.alt = alt;
        requestAnimationFrame(function () { img.style.opacity = '1'; });
      };
      pre.src = src;
    }

    function all(attr, n, fn) { root.querySelectorAll('[' + attr + '="' + n + '"]').forEach(fn); }

    function render() {
      var total = 0, ids = [], ok = true;
      [1, 2].forEach(function (n) {
        var h = sel[n - 1], p = P[h], v = vOf(h);
        all('data-art', n, function (img) { if (p) swap(img, p.img, p.t); });
        all('data-thumb', n, function (img) { if (p) swap(img, p.th, ''); });
        all('data-name', n, function (el) { el.textContent = p ? p.t : ''; });
        all('data-meta', n, function (el) { el.textContent = v ? 'Framed · ' + size : 'Not available in ' + size; });
        all('data-price', n, function (el) { el.textContent = v ? money(v.p) : ''; });
        all('data-link', n, function (a) { if (p) a.href = p.u + (v ? '?variant=' + v.id : ''); });
        if (v && v.ok) { total += v.p; ids.push(v.id); } else { ok = false; }
      });
      root.querySelectorAll('[data-size-label]').forEach(function (el) { el.textContent = size; });
      var after = ids.length === 2 ? total - DISC : total;
      var t = root.querySelector('[data-total]'), was = root.querySelector('[data-was]');
      if (t) t.textContent = money(after);
      if (was) { was.textContent = money(total); was.hidden = after === total; }
      if (btn) { btn.disabled = !ok; btn.dataset.ids = ids.join(','); }
    }

    /* Picker list */
    function close() {
      if (!openFor) return;
      pop.classList.remove('is-open');
      openFor.setAttribute('aria-expanded', 'false');
      openFor = null;
    }
    function build(kind) {
      var html = '';
      if (kind === 'size') {
        (data.sizes || []).forEach(function (sz) {
          var a = vOf(sel[0], sz), b = vOf(sel[1], sz);
          var ok = a && b && a.ok && b.ok;
          var price = ok ? money(a.p + b.p - DISC) + ' the pair' : 'Unavailable';
          html += '<button type="button" role="option" class="pw-opt' + (sz === size ? ' is-on' : '') + '" data-val="' + esc(sz) + '"' + (ok ? '' : ' disabled') + ' aria-selected="' + (sz === size) + '">' +
            '<span class="pw-opt__t">' + esc(sz) + '</span><span class="pw-opt__s">' + price + '</span></button>';
        });
      } else {
        var slot = Number(kind.slice(-1)) - 1, other = sel[1 - slot];
        (data.groups || []).forEach(function (g) {
          if (!g.h || !g.h.length) return;
          html += '<div class="pw-pop__group" role="presentation">' + esc(g.t) + '</div>';
          g.h.forEach(function (h) {
            var p = P[h]; if (!p) return;
            var on = h === sel[slot], taken = h === other, v = vOf(h);
            html += '<button type="button" role="option" class="pw-opt' + (on ? ' is-on' : '') + '" data-val="' + esc(h) + '"' + (taken ? ' disabled' : '') + ' aria-selected="' + on + '">' +
              (p.th ? '<img src="' + esc(p.th) + '" alt="" width="34" height="42" loading="lazy">' : '') +
              '<span class="pw-opt__t">' + esc(p.t) + '</span>' +
              '<span class="pw-opt__s">' + (taken ? 'In frame ' + (2 - slot) : (v ? money(v.p) : '')) + '</span></button>';
          });
        });
      }
      pop.innerHTML = html;
      pop.dataset.kind = kind;
    }
    function place(trigger) {
      var r = trigger.getBoundingClientRect();
      var vw = document.documentElement.clientWidth, vh = window.innerHeight;
      var w = Math.min(Math.max(r.width, 300), vw - 24);
      pop.style.width = w + 'px';
      var left = pop.dataset.kind === 'size' ? r.left : r.right - w;
      pop.style.left = Math.min(Math.max(12, left), vw - w - 12) + 'px';
      var h = Math.min(pop.scrollHeight, 360);
      var below = vh - r.bottom - 12;
      pop.style.top = ((below < h && r.top - 12 > below) ? Math.max(12, r.top - 8 - h) : r.bottom + 8) + 'px';
    }
    function open(trigger) {
      var kind = trigger.dataset.open;
      if (openFor === trigger) { close(); return; }
      close();
      build(kind);
      openFor = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      pop.classList.add('is-open');
      place(trigger);
      var cur = pop.querySelector('.pw-opt.is-on') || pop.querySelector('.pw-opt:not([disabled])');
      if (cur) { pop.scrollTop = Math.max(0, cur.offsetTop - 70); cur.focus({ preventScroll: true }); }
    }

    root.querySelectorAll('[data-open]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.stopPropagation(); open(t); });
    });
    pop.addEventListener('click', function (e) {
      var o = e.target instanceof Element ? e.target.closest('.pw-opt') : null;
      if (!o || o.disabled) return;
      e.stopPropagation();
      var kind = pop.dataset.kind, val = o.dataset.val, trigger = openFor;
      if (kind === 'size') size = val; else sel[Number(kind.slice(-1)) - 1] = val;
      close();
      render();
      if (trigger) trigger.focus({ preventScroll: true });
    });
    document.addEventListener('click', function (e) {
      if (openFor && !(e.target instanceof Element && pop.contains(e.target))) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!openFor) return;
      if (e.key === 'Escape') { var t = openFor; close(); t.focus(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var opts = Array.prototype.slice.call(pop.querySelectorAll('.pw-opt:not([disabled])'));
        var i = opts.indexOf(document.activeElement);
        i = e.key === 'ArrowDown' ? Math.min(opts.length - 1, i + 1) : Math.max(0, i - 1);
        if (opts[i]) opts[i].focus();
      }
    });
    function follow() {
      if (!openFor) return;
      var r = openFor.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) { close(); return; }
      place(openFor);
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(follow); }, { passive: true });
    window.addEventListener('resize', close);

    /* Add both to the cart.
       Section Store Cart is only safe to use once SectionStoreCart.ready resolves
       (phones often tap before that). So: wait for it, add through Shopify's own
       cart API, check the cart really has the items, then refresh and open the drawer. */
    var busy = false;
    function settle(promise, ms) {
      return Promise.race([
        Promise.resolve(promise).then(function () { return true; }, function () { return false; }),
        new Promise(function (res) { setTimeout(function () { res(false); }, ms); })
      ]);
    }
    function getCart() {
      return fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); });
    }
    function hasAll(cart, ids) {
      var got = {};
      (cart.items || []).forEach(function (it) { got[it.variant_id] = true; });
      return ids.every(function (id) { return got[id]; });
    }
    if (btn) btn.addEventListener('click', function () {
      if (busy) return;
      var ids = (btn.dataset.ids || '').split(',').filter(Boolean).map(Number);
      if (ids.length !== 2) return;
      var items = ids[0] === ids[1] ? [{ id: ids[0], quantity: 2 }] : [{ id: ids[0], quantity: 1 }, { id: ids[1], quantity: 1 }];
      busy = true;
      if (err) err.hidden = true;
      btn.setAttribute('aria-busy', 'true');
      function done() { busy = false; btn.removeAttribute('aria-busy'); }
      function fail() { done(); if (err) err.hidden = false; }
      function toCart() { window.location.href = base + 'cart'; }
      function add(list) {
        return fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: list || items })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
      }
      var ssc = window.SectionStoreCart;
      var ready = ssc && ssc.ready ? settle(ssc.ready, 8000) : Promise.resolve(!!ssc);
      ready.then(function (isReady) {
        return add()
          .then(getCart)
          .then(function (cart) {
            if (hasAll(cart, ids)) return cart;
            var got = {};
            (cart.items || []).forEach(function (it) { got[it.variant_id] = true; });
            var missing = items.filter(function (it) { return !got[it.id]; });
            return add(missing).then(getCart);
          })
          .then(function (cart) {
            if (!hasAll(cart, ids)) throw new Error('not in cart');
            ssc = window.SectionStoreCart;
            if (!isReady || !ssc || typeof ssc.open !== 'function') { toCart(); return; }
            return settle(typeof ssc.refresh === 'function' ? ssc.refresh() : null, 5000)
              .then(function () { if (!ssc.isOpen || !ssc.isOpen()) ssc.open(); done(); });
          });
      }).catch(fail);
    });

    render();
  }

  function start() { document.querySelectorAll('.aes-pw').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.aes-pw'); if (r) bind(r); });
})();